// extracted by mini-css-extract-plugin
module.exports = {"root":"HasContent_root__2glos"};